<template>
  <Dialog
    title="设置路由"
    :visible="visible"
    @close="handleClose"
    width="600px"
  >
    <Form
      ref="form"
      label-width="60px"
      :model="form"
      :rules="rules"
    >
      <FormItem
        label="名称"
        prop="name"
      >
        <Input v-model="form.name" />
      </FormItem>
      <FormItem
        label="路由"
        prop="api"
      >
        <Cascader
          v-model="form.api"
          :options="routes"
          :props="props"
        />
      </FormItem>
    </Form>

    <Button
      style="float: right"
      type="primary"
      @click="create"
    >
      新增
    </Button>

    <h3 style="margin-top: 80px">路由列表</h3>
    <Table :data="dataSource.data">
      <TableColumn
        label="名称"
        prop="name"
      />
      <TableColumn
        label="api"
        prop="api"
      />
      <TableColumn
        label="操作"
      >
        <template slot-scope="scope">
          <Button
            type="text"
            @click="remove(scope.row)"
          >
            删除
          </Button>
        </template>
      </TableColumn>
    </Table>
  </Dialog>
</template>

<script>
import {
  Dialog,
  Button,
  Form,
  FormItem,
  Input,
  Cascader,
  Table,
  TableColumn,
} from 'element-ui';
import Request from '@/core/QuRequest';

const req = new Request();

export default {
  components: {
    Dialog,
    Button,
    Form,
    FormItem,
    Input,
    Cascader,
    Table,
    TableColumn,
  },

  props: {
    visible: {
      type: Boolean,
      default: false,
    },

    dataSource: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  data() {
    return {
      form: {
        name: '',
        api: '',
      },
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        api: [{ required: true, message: '请输入路由', trigger: 'blur' }],
      },
      routes: [],
      props: {
        lazy: true,
        lazyLoad: this.getActions,
      },
    };
  },

  created() {
    this.getControllers();
  },

  methods: {
    handleClose() {
      this.$emit('update:visible', false);
    },

    create() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const d = {
            perm_id: this.dataSource.id,
            ...this.form,
            api: this.form.api.join('/'),
          };
          // this.form.perm_id = this.dataSource.id;
          this.$emit('create', d);
          this.$refs.form.resetFields();
        }
      });
    },

    remove(data) {
      this.$confirm('你确定要删除当前路由吗？').then(() => {
        this.$emit('remove', data);
      });
    },

    async getControllers() {
      try {
        const res = await req.send(req.Apis.sales.user.getControllers);
        if (res && res.code === 200) {
          this.routes = res.data.map((item) => {
            return { value: item, label: item };
          });
        }
      } catch (err) {
        this.$message.error(`${err.message || '未知错误'}`);
      }
    },

    async getActions(node, resolve) {
      // console.dir(node);
      try {
        const res = await req.send(req.Apis.sales.user.getActions, {
          controller: node.value,
        });
        if (res && res.code === 200) {
          const list = res.data.map((item) => {
            return { value: item, label: item, leaf: true };
          });
          resolve(list);
        }
      } catch (err) {
        this.$message.error(`${err.message || '未知错误'}`);
      }
    },
  },
};
</script>